import type { GeometrySpatialRuleConfig } from "@/types/card-template";

/**
 * Человекочитаемые подсказки по spatial_config шаблона (этап 2, совместимо с backend SpatialRuleConfig).
 */
export function spatialConfigToUserHints(
  cfg: GeometrySpatialRuleConfig | null | undefined,
): string[] {
  if (!cfg) return [];
  const out: string[] = [];

  if (cfg.must_be_inside?.length) {
    out.push(
      `Геометрия должна полностью находиться внутри объединения оболочек с семантическими KLS id: ${cfg.must_be_inside.join(", ")}.`,
    );
  }
  if (cfg.cannot_overlap?.length) {
    out.push(
      `Не должна пересекаться по площади с геометриями типов (семантические KLS id): ${cfg.cannot_overlap.join(", ")}.`,
    );
  }
  if (cfg.must_not_intersect?.length) {
    out.push(
      `Не должна пересекаться и касаться геометрий типов (KLS id): ${cfg.must_not_intersect.join(", ")}.`,
    );
  }
  const ab = cfg.area_bounds;
  if (ab && (ab.min != null || ab.max != null)) {
    const lo = ab.min != null ? `${ab.min} м²` : "—";
    const hi = ab.max != null ? `${ab.max} м²` : "—";
    out.push(`Для полигонов: допустимая площадь ${lo} … ${hi} (эллипсоид WGS84).`);
  }
  const lb = cfg.length_bounds;
  if (lb && (lb.min != null || lb.max != null)) {
    const lo = lb.min != null ? `${lb.min} м` : "—";
    const hi = lb.max != null ? `${lb.max} м` : "—";
    out.push(`Для линий: допустимая длина ${lo} … ${hi}.`);
  }
  return out;
}
